"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _cccisdFormik = require("cccisd-formik");
var _eye = _interopRequireDefault(require("cccisd-icons/eye"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _formulaVariables = _interopRequireDefault(require("../../formulaVariables.graphql"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var elementIcons = {};
_cccisdLaravelFlow.allElements.forEach(function (element) {
  elementIcons[element.code] = element.icon;
});
var Variables = function Variables(_ref) {
  var updatingVariableId = _ref.updatingVariableId;
  var currentAssignmentId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentAssignmentId;
  });
  var graphqlVariables = {
    assignmentId: currentAssignmentId,
    variableId: updatingVariableId,
    typeFilter: ['quantitative', 'formula', 'additional_coding']
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "variables",
    label: "Variables",
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
        field: field,
        form: form,
        label: "Select variables to use in Equation"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].errorOff
      }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
        query: _formulaVariables["default"],
        rowKey: "reportHeader",
        graphqlVariables: graphqlVariables,
        perPage: 10,
        rowActions: [{
          name: 'Do something',
          action: function action() {}
        }],
        showRowActions: false,
        selectedRows: field.value,
        keepSelectedOnFiltering: true,
        rowSelectedCallback: function rowSelectedCallback(selectedRows) {
          if (selectedRows.length !== field.value.length) {
            form.setFieldValue('variables', selectedRows);
          }
        },
        columns: [{
          name: 'actions',
          label: '',
          rowSpanBy: 'key.entityId',
          render: function render(_ref3) {
            var value = _ref3.value,
              row = _ref3.row;
            if (row.type === 'formula') {
              return null;
            }
            return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
              trigger: /*#__PURE__*/_react["default"].createElement("button", {
                type: "button",
                className: "btn btn-primary btn-xs",
                "data-preview-question": row['key.keyId']
              }, /*#__PURE__*/_react["default"].createElement(_eye["default"], null)),
              title: "Question preview"
            }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.ElementPreview, {
              entityId: row['key.entityId']
            }));
          }
        }, {
          name: 'key.title',
          label: 'Question',
          rowSpanBy: 'key.entityId',
          filter: true,
          render: function render(_ref4) {
            var value = _ref4.value,
              row = _ref4.row;
            var type = row['key.entity.type'];
            return type ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].questionType
            }, elementIcons[type] && /*#__PURE__*/_react["default"].createElement("div", null, elementIcons[type]), /*#__PURE__*/_react["default"].createElement("div", null, type)), value) : value;
          }
        }, {
          name: 'key.metric',
          label: 'Metric',
          filter: true
        }, {
          name: 'reportHeader',
          label: 'Variable',
          filter: true
        }, {
          name: 'label',
          label: 'Label',
          filter: true
        }]
      })));
    }
  });
};
Variables.propTypes = {
  updatingVariableId: _propTypes["default"].number
};
var _default = exports["default"] = Variables;